// ConsultingFormTabs.jsx

import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

const ConsultingFormTabs = () => {
    const [activeTab, setActiveTab] = useState('book');
    const history = useHistory();

    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', color: 'white', padding: '40px', minHeight: '100vh' }}>
            {/* Tabs */}
            <div style={{ display: 'flex', gap: '40px', marginBottom: '30px', borderBottom: '1px solid #444' }}>
                <button
                    onClick={() => setActiveTab('book')}
                    style={{
                        border: 'none',
                        borderBottom: activeTab === 'book' ? '2px solid violet' : 'none',
                        background: 'none',
                        color: activeTab === 'book' ? 'white' : 'gray',
                        padding: '10px 20px',
                        cursor: 'pointer',
                        fontWeight: 'bold'
                    }}
                >
                    Book a Consultent
                </button>
                <button
                    onClick={() => setActiveTab('become')}
                    style={{
                        border: 'none',
                        borderBottom: activeTab === 'become' ? '2px solid violet' : 'none',
                        background: 'none',
                        color: activeTab === 'become' ? 'white' : 'gray',
                        padding: '10px 20px',
                        cursor: 'pointer',
                        fontWeight: 'bold'
                    }}
                >
                    Become a Consultent
                </button>
            </div>

            {/* Forms */}
            <div style={{ width: '100%', maxWidth: '800px' }}>
                {activeTab === 'book' ? <BookForm history={history} /> : <BecomeForm />}
            </div>
        </div>
    );
};

// Common styles
const inputStyle = {
    backgroundColor: 'white',
    border: '1px solid #555',
    padding: '10px',
    borderRadius: '5px',
    width: '100%',
    boxSizing: 'border-box'
};

const labelStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    color: 'white',
    fontWeight: 'bold',
    fontSize: '14px',
    flex: 1
};

const rowStyle = {
    display: 'flex',
    gap: '20px',
    width: '100%',
    flexWrap: 'wrap'
};

// BookForm
const BookForm = ({ history }) => {
    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        company: '',
        title: '',
        email: '',
        phone: '',
        interested_speaker: '',
        event_name: '',
        event_date: '',
        event_location: '',
        event_budget: '',
        event_website: '',
        additional_info: '',
        receive_updates: false
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
            const response = await fetch(`${API_BASE_URL}/consulting/book`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });

            if (response.ok) {
                setFormData({
                    first_name: '',
                    last_name: '',
                    company: '',
                    title: '',
                    email: '',
                    phone: '',
                    interested_speaker: '',
                    event_name: '',
                    event_date: '',
                    event_location: '',
                    event_budget: '',
                    event_website: '',
                    additional_info: '',
                    receive_updates: false
                });
                history.push('/thank-you');
            } else {
                alert('Failed to submit form.');
            }
        } catch (error) {
            console.error('Error:', error);
            alert('An error occurred while submitting.');
        }
    };

    return (
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <div style={rowStyle}>
                <label style={labelStyle}>
                    First Name *
                    <input name="first_name" value={formData.first_name} onChange={handleChange} style={inputStyle} required />
                </label>
                <label style={labelStyle}>
                    Last Name *
                    <input name="last_name" value={formData.last_name} onChange={handleChange} style={inputStyle} required />
                </label>
            </div>
            <div style={rowStyle}>
                <label style={labelStyle}>
                    Company *
                    <input name="company" value={formData.company} onChange={handleChange} style={inputStyle} required />
                </label>
                <label style={labelStyle}>
                    Title *
                    <input name="title" value={formData.title} onChange={handleChange} style={inputStyle} required />
                </label>
            </div>
            <div style={rowStyle}>
                <label style={labelStyle}>
                    Email *
                    <input type="email" name="email" value={formData.email} onChange={handleChange} style={inputStyle} required />
                </label>
                <label style={labelStyle}>
                    Phone *
                    <input type="tel" name="phone" value={formData.phone} onChange={handleChange} style={inputStyle} required />
                </label>
            </div>
            <label style={labelStyle}>
                Which consultent are you interested in?
                <select name="interested_speaker" value={formData.interested_speaker} onChange={handleChange} style={inputStyle} required>
                    <option value="">Select Consultent</option>
                    <option>Jahid Hasan</option>
                    <option>Other</option>
                </select>
            </label>
            <hr style={{ borderColor: '#444' }} />
            <h4>Event Details</h4>
            <div style={rowStyle}>
                <label style={labelStyle}>
                    Event Name
                    <input name="event_name" value={formData.event_name} onChange={handleChange} style={inputStyle} />
                </label>
                <label style={labelStyle}>
                    Event Date
                    <input type="date" name="event_date" value={formData.event_date} onChange={handleChange} style={inputStyle} />
                </label>
            </div>
            <label style={labelStyle}>
                Event Location *
                <input name="event_location" value={formData.event_location} onChange={handleChange} style={inputStyle} required />
            </label>
            <label style={labelStyle}>
                Event Budget
                <select name="event_budget" value={formData.event_budget} onChange={handleChange} style={inputStyle}>
                    <option value="">Select budget</option>
                    <option value="low">$0 - $100</option>
                    <option value="medium">$100 - $500</option>
                    <option value="high">$500 - $1000+</option>
                </select>
            </label>
            <label style={labelStyle}>
                Event Website Link
                <input type="url" name="event_website" value={formData.event_website} onChange={handleChange} style={inputStyle} />
            </label>
            <label style={labelStyle}>
                Additional Information
                <textarea name="additional_info" value={formData.additional_info} onChange={handleChange} style={{ ...inputStyle, height: '150px' }}></textarea>
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <input type="checkbox" name="receive_updates" checked={formData.receive_updates} onChange={handleChange} />
                Yes, I’d like to receive updates
            </label>
            <button type="submit" className="btn-default">
                Submit
            </button>
        </form>
    );
};

// BecomeForm
const BecomeForm = () => {
    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        company: '',
        title: '',
        email: '',
        phone: '',
        website_link: '',
        video_link: '',
        speaking_fees: '',
        speaking_experience: '',
        topics: '',
        why_join: '',
        receive_updates: false
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
            const response = await fetch(`${API_BASE_URL}/consulting/become`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });

            if (response.ok) {
                alert('Form submitted successfully!');
                setFormData({
                    first_name: '',
                    last_name: '',
                    company: '',
                    title: '',
                    email: '',
                    phone: '',
                    website_link: '',
                    video_link: '',
                    speaking_fees: '',
                    speaking_experience: '',
                    topics: '',
                    why_join: '',
                    receive_updates: false
                });
            } else {
                alert('Failed to submit form.');
            }
        } catch (error) {
            console.error('Error:', error);
            alert('An error occurred while submitting.');
        }
    };

    return (
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <div style={rowStyle}>
                <label style={labelStyle}>
                    First Name *
                    <input name="first_name" value={formData.first_name} onChange={handleChange} style={inputStyle} required />
                </label>
                <label style={labelStyle}>
                    Last Name *
                    <input name="last_name" value={formData.last_name} onChange={handleChange} style={inputStyle} required />
                </label>
            </div>
            <div style={rowStyle}>
                <label style={labelStyle}>
                    Company *
                    <input name="company" value={formData.company} onChange={handleChange} style={inputStyle} required />
                </label>
                <label style={labelStyle}>
                    Title *
                    <input name="title" value={formData.title} onChange={handleChange} style={inputStyle} required />
                </label>
            </div>
            <div style={rowStyle}>
                <label style={labelStyle}>
                    Email *
                    <input type="email" name="email" value={formData.email} onChange={handleChange} style={inputStyle} required />
                </label>
                <label style={labelStyle}>
                    Phone *
                    <input type="tel" name="phone" value={formData.phone} onChange={handleChange} style={inputStyle} required />
                </label>
            </div>
            <label style={labelStyle}>
                Website Link
                <input type="url" name="website_link" value={formData.website_link} onChange={handleChange} style={inputStyle} />
            </label>
            <label style={labelStyle}>
                Video Link
                <input type="url" name="video_link" value={formData.video_link} onChange={handleChange} style={inputStyle} />
            </label>
            <label style={labelStyle}>
                Speaking Fees
                <input name="speaking_fees" value={formData.speaking_fees} onChange={handleChange} style={inputStyle} />
            </label>
            <label style={labelStyle}>
                Speaking Experience
                <textarea name="speaking_experience" value={formData.speaking_experience} onChange={handleChange} style={{ ...inputStyle, height: '100px' }}></textarea>
            </label>
            <label style={labelStyle}>
                Topics you speak about
                <textarea name="topics" value={formData.topics} onChange={handleChange} style={{ ...inputStyle, height: '100px' }}></textarea>
            </label>
            <label style={labelStyle}>
                Why do you want to join?
                <textarea name="why_join" value={formData.why_join} onChange={handleChange} style={{ ...inputStyle, height: '100px' }}></textarea>
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <input type="checkbox" name="receive_updates" checked={formData.receive_updates} onChange={handleChange} />
                Yes, I’d like to receive updates
            </label>
            <button type="submit" className="btn-default">
                Submit
            </button>
        </form>
    );
};

export default ConsultingFormTabs;
